module.exports = __webpack_public_path__ + "static/media/background.09421401.jpg";